module.exports = __webpack_public_path__ + "img/znjj.33beb8ea.png";